import api from '../api.js';

/**
 * 通知中心API接口
 */
export const notificationsApi = {
    /**
     * 获取用户所有通知
     * @param {string} userId - 用户ID
     */
    getUserNotifications: (userId) => {
        return api.get('/notifications', { params: { userId } });
    },

    /**
     * 获取未读通知
     * @param {string} userId - 用户ID
     */
    getUnreadNotifications: (userId) => {
        return api.get('/notifications/unread', { params: { userId } });
    },

    /**
     * 获取未读通知数量
     * @param {string} userId - 用户ID
     */
    getUnreadCount: (userId) => {
        return api.get('/notifications/count', { params: { userId } });
    },

    /**
     * 获取通知统计
     * @param {string} userId - 用户ID
     */
    getNotificationStats: (userId) => {
        return api.get('/notifications/stats', { params: { userId } });
    },

    /**
     * 标记通知为已读
     * @param {string} notificationId - 通知ID
     * @param {string} userId - 用户ID
     */
    markAsRead: (notificationId, userId) => {
        return api.put(`/notifications/${notificationId}/read`, null, { params: { userId } });
    },

    /**
     * 标记所有通知为已读
     * @param {string} userId - 用户ID
     */
    markAllAsRead: (userId) => {
        return api.put('/notifications/read-all', null, { params: { userId } });
    },

    /**
     * 创建通知
     * @param {Object} notification - 通知数据
     * @param {string} notification.title - 通知标题
     * @param {string} notification.content - 通知内容
     * @param {string} notification.type - 通知类型
     * @param {string} notification.userId - 用户ID
     * @param {string} notification.tenantId - 租户ID
     */
    createNotification: (notification) => {
        return api.post('/notifications', notification);
    },

    /**
     * 创建系统通知（发送给所有用户）
     * @param {Object} notification - 通知数据
     * @param {string} notification.content - 通知内容
     * @param {string} notification.type - 通知类型
     */
    createSystemNotification: (notification) => {
        return api.post('/notifications/system', notification);
    },

    /**
     * 获取预警通知渠道配置
     * @param {string} [tenantId]
     */
    getNotificationSettings: (tenantId) => {
        return api.get('/notification-settings', {
            params: tenantId ? { tenantId } : undefined
        });
    },

    /**
     * 保存预警通知渠道配置（创建或更新）
     * @param {Object} settings - email/sms/push 配置
     * @param {Object} [options]
     * @param {string} [options.tenantId]
     * @param {string} [options.updatedBy]
     */
    saveNotificationSettings: (settings, options = {}) => {
        const params = {};
        if (options.tenantId) params.tenantId = options.tenantId;
        if (options.updatedBy) params.updatedBy = options.updatedBy;
        return api.put('/notification-settings', settings, { params });
    },

    /**
     * 删除/重置预警通知渠道配置
     * @param {string} [tenantId]
     */
    deleteNotificationSettings: (tenantId) => {
        return api.delete('/notification-settings', {
            params: tenantId ? { tenantId } : undefined
        });
    }
};

export default notificationsApi;

